import React from 'react';

const BS_Modal = () => {
    return (
        <div>
            <h1>BS_Modal Component</h1>
            <p>Content coming soon...</p>
        </div>
    );
}

export default BS_Modal;
